import type { FC, SVGProps } from 'react';

export const SmartyLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 73.229 71.607"
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#06f"
      d="M36.615,0C16.259,0,0,15.459,0,35.742s15.763,35.865,36.615,35.865h36.615v-35.865C73.229,15.335,57.094,0,36.615,0ZM36.73,53.574c-9.844,0-17.014-7.464-17.014-17.7,0-10.449,7.169-17.594,17.014-17.594s16.908,7.144,16.908,17.594c0,10.236-5.779,17.7-16.908,17.7Z"
    />
  </svg>
);
